<template>
    <div>
        <modal :title="trans('general.planners.select_a_planner')" v-model="toggleSelectPlannerModal">
            <custom-radio
                ref="choosePlanner"
                type="list"
                v-if="plannersDesigner"
                v-model="choosePlanner"
                :items="plannersDesigner"/>
        </modal>

        <component
            :key="planKey"
            v-if="selectedPlanner"
            :is="component"
            :event-type="type"
            :planner-id="selectedPlanner.id"
            ref="plannerForm"
            v-on="$listeners"
            v-on:event-saved="planSaved">
        </component>
    </div>
</template>

<script>
import moment from "moment/moment";
import CustomRadio from "../../molecules/CustomRadio.vue";
import axios from "axios";
import modal from "../Modal.vue";

export default {
    name: "Plan",
    components: {CustomRadio, modal},
    data() {
        return {
            planKey: 0,
            planners: [],
            selectedPlanner: null,
            toggleSelectPlannerModal: false,
            plannersDesigner: [],
            choosePlanner: null,
        }
    },
    watch: {
        choosePlanner(val) {
            if(val !== undefined && val !== null) {
                this.selectPlanner(val.data);
                this.toggleSelectPlannerModal = false;
            }
        }
    },
    methods: {
        init() {
            this.getActivePlanner(this.type);
        },

        selectPlanner(planner) {
            this.selectedPlanner = planner;
            this.planKey++;

            this.$nextTick(() => {
                if(this.$refs.plannerForm) {
                    const model = {start: moment(new Date()).format('YYYY-MM-DD HH:mm')}
                    this.$refs.plannerForm.open(model);
                }
            });
        },

        designPlanners() {
            let items = [];

            this.planners.forEach((item) => {
                items.push({
                    value: item.id,
                    cls: 'planner-card',
                    text: item.name,
                    color: 'text-center',
                    icon: this.getPlanIconByType(),
                    data: item,
                });
            });

            this.plannersDesigner = items;
        },

        getPlanIconByType() {
            const typeToIconMap = {
                menu: 'fi-rr-utensils',
                activity: 'fi-rr-triangle',
                event: 'fi-rr-calendar-star',
                meeting: 'fi-rr-calendar-day'
            };

            return typeToIconMap[this.type] || '';
        },

        getActivePlanner(type) {
            axios.get(`/planners/${type}/active`).then(response => {
                const data = response.data.data;

                if(data.length > 0) {
                    if(data.length > 1) {
                        this.planners = data;
                        this.toggleSelectPlannerModal = true;
                        this.designPlanners()
                    } else {
                        this.selectPlanner(data[0])
                    }
                } else {
                    this.createFirstPlanner();
                }
            });
        },

        createFirstPlanner() {
            let model = {
                type: this.type,
                name: trans(`general.quick_call.planner.first_${this.type}_planner`),
                start: new Date(),
            }

            axios.post(`/planners/new`, model).then(response => {
                const data = response.data.data
                this.selectPlanner(data)
            });
        },

        planSaved() {
            this.$refs.plannerForm.close()

            if(this.type !== 'menu' && this.type !== 'activity') {
                this.$emit('reload-events');
            }

            this.$notify({type: 'success', text: trans(`general.quick_call.${this.type}_plan_added`)})
        }
    },
}
</script>
